import { useState } from 'react';
import { Card } from '@mui/material';
import PropTypes from 'prop-types';
import ItemResultDialog from './ItemResultDialog';
import OrderResult from './OrderResult';

OrderSearchResult.propTypes = {
  searchResult: PropTypes.object,
  search: PropTypes.string,
  isDialog: PropTypes.bool
};

export default function OrderSearchResult({ searchResult, search, isDialog = false }) {
  const searchValue = search;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Card variant="outlined" sx={{border: "1.5px #e5e9ed solid", p: 2, mb: 2, boxShadow: 'none', borderRadius: '20px'}}>
        <OrderResult
          searchResult={searchResult}
          searchValue={searchValue}
          isDialog={isDialog}
          setIsDialogOpen={setIsDialogOpen}
        />
      </Card>
      <ItemResultDialog
        searchType="orders"
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        searchResult={searchResult}
        search={search}
      />
    </>);
}
